import EmployeeQueueTaskAccessEnum from '../../../../../../projects/performers/enums/EmployeeQueueTaskAccessEnum';

/**
 * * Модель пользователя для запроса на добавление прав
 */
export default class UpdateQueueTaskEmployeeRoleAccessListUserItem  {
	/**
	 * * Номер пользователя
	 */
	UserId!: number;
	/**
	 * * Список доступов
	 */
	Accesses!: Array<EmployeeQueueTaskAccessEnum>;
	constructor(obj?: Partial<UpdateQueueTaskEmployeeRoleAccessListUserItem>) {
		if (obj) {
			Object.assign(this, obj);
		}
	}
}
